import { inject, Injectable } from '@angular/core';
import { HttpAgent, type AgentSubscriber } from '@ag-ui/client';
import { KeycloakClient } from '@core/services/keycloak/keycloak.client';
import { environment } from '@environments/environment';

@Injectable()
export class AgUiChatTransport {
  private readonly keycloakClient = inject(KeycloakClient);

  private readonly chatAgentUrl = environment.agent.url;

  readonly agent = new HttpAgent({
    url: `${this.chatAgentUrl}/chat`,
    fetch: async (input, init) => {
      const headers = new Headers(init?.headers);
      headers.set(
        'Authorization',
        `Bearer ${this.keycloakClient.getAccessToken()}`,
      );
      return globalThis.fetch(input, { ...init, headers });
    },
  });

  async run(subscriber: AgentSubscriber): Promise<void> {
    await this.agent.runAgent({ forwardedProps: {} }, subscriber);
  }

  abort(): void {
    this.agent.abortRun();
  }

  resetThread(): void {
    this.agent.setMessages([]);
    this.agent.setState({});
    this.agent.threadId = crypto.randomUUID();
  }
}
